import { CustomStringParam, FilterType, SchemaFilterType } from '@ui/src';
import { CustomerStatus } from '../../../common/types';

export const corporateCustomersListColumns = [
  {
    name: 'id',
    label: '',
    hidden: true,
  },
  {
    name: 'ids',
    label: 'Organization identifier',
    hidden: true,
  },
  {
    name: 'companyName',
    label: 'Entity name',
    sortale: false,
  },
  {
    name: 'type',
    label: 'Entity form',
  },
  {
    name: 'dateOfIncorporation',
    label: 'Incorp. date',
  },
  {
    name: 'countryOfIncorporationId',
    label: 'Country of incorp',
  },
  {
    name: 'status',
    label: 'Status',
    filterModalPlacement: 'right',
  },
];

export const corporateCustomersListColumnsLabels = {
  status: 'Status',
  ids: 'Organization identifier',
};

export const corporateCustomersListDefaultSorter = {};

export const corporateCustomersListSchema = {
  companyName: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  status: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
  ids: {
    value: CustomStringParam,
    type: SchemaFilterType.STRING,
  },
};

export const corporateCustomersListFiltersSchema = [
  {
    name: 'status',
    type: FilterType.CHECKBOX,
    fields: [
      {
        name: 'status',
        title: 'Active',
        value: CustomerStatus.ACTIVE,
      },
      {
        name: 'status',
        title: 'Closed',
        value: CustomerStatus.CLOSED,
      },
    ],
  },
  {
    name: 'ids',
    type: FilterType.TEXT,
    placeholder: 'Enter ID',
  },
];
